import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ShieldCheck, Facebook, Instagram, Linkedin } from "lucide-react";
import { LOGO_SRC, WHATSAPP_LINK, WHATSAPP_DISPLAY, EMAIL } from "@/lib/site";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);

const SOCIALES = [
  { nombre: "Facebook", icon: Facebook },
  { nombre: "Instagram", icon: Instagram },
  { nombre: "LinkedIn", icon: Linkedin },
];

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-[#0C5F8A] text-white">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-3">
        <div>
          <span className="inline-block rounded-xl bg-white px-4 py-2.5 shadow-md">
            <img src={LOGO_SRC} alt="Seguclick — agencia de seguros familiar" className="h-10 w-auto" />
          </span>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/80">
            Seguclick — Protegiendo familias desde hace más de 60 años
          </p>
          <div className="mt-6 flex gap-3">
            {SOCIALES.map((s) => (
              <a
                key={s.nombre}
                href="#"
                onClick={(e) => e.preventDefault()}
                data-testid={`social-${s.nombre.toLowerCase()}`}
                aria-label={`${s.nombre} de Seguclick (próximamente)`}
                title="Próximamente"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/25 text-white/80 transition-all duration-300 hover:border-[#F5B21B] hover:bg-[#F5B21B] hover:text-[#0C5F8A]"
              >
                <s.icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-[0.22em] text-[#F5B21B]">
            Contacto
          </h3>
          <ul className="mt-5 space-y-3.5 text-sm text-white/85">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 shrink-0 text-[#1BA8E0]" />
              <span data-testid="footer-telefono">Teléfono: [PENDIENTE]</span>
            </li>
            <li className="flex items-center gap-3">
              <WhatsAppIcon className="h-4 w-4 shrink-0 text-[#1BA8E0]" />
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="transition-colors hover:text-[#F5B21B]">
                WhatsApp: {WHATSAPP_DISPLAY}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 shrink-0 text-[#1BA8E0]" />
              <a href={`mailto:${EMAIL}`} data-testid="footer-correo" className="transition-colors hover:text-[#F5B21B]">
                {EMAIL}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-4 w-4 shrink-0 text-[#1BA8E0]" />
              <span data-testid="footer-direccion">Dirección: [PENDIENTE]</span>
            </li>
            <li className="flex items-center gap-3">
              <Clock className="h-4 w-4 shrink-0 text-[#1BA8E0]" />
              <span data-testid="footer-horario">Horario: [PENDIENTE]</span>
            </li>
            <li className="flex items-center gap-3">
              <ShieldCheck className="h-4 w-4 shrink-0 text-[#1BA8E0]" />
              <span data-testid="footer-cnsf">Clave de agente CNSF: [PENDIENTE]</span>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-[0.22em] text-[#F5B21B]">
            Legal
          </h3>
          <ul className="mt-5 space-y-3.5 text-sm text-white/85">
            <li>
              <Link to="/aviso-de-privacidad" data-testid="footer-aviso-privacidad" className="transition-colors hover:text-[#F5B21B]">
                Aviso de Privacidad
              </Link>
            </li>
          </ul>
          <p className="mt-8 font-editorial text-lg text-white/70">
            “Estar contigo cuando importa.”
          </p>
        </div>
      </div>

      <div className="mt-14 border-t border-white/15 pt-7 text-center text-xs text-white/60">
        © {new Date().getFullYear()} Seguclick. Todos los derechos reservados.
      </div>
    </div>
  </footer>
);
